import PropTypes from "prop-types";
import { useLocation, Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectCurrentRoles, selectCurrentToken } from "./authSlice";
import { ROLES_LIST } from "../roles/roles.config";
import { checkAuthorized } from "../../utils/checkAuthorized";

const RequireAuth = ({ allowedRoles = [] }) => {
  const token = useSelector(selectCurrentToken);
  const roles = useSelector(selectCurrentRoles) || [];
  const location = useLocation();

  if (!token) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (
    Array.isArray(allowedRoles) &&
    allowedRoles.length > 0 &&
    !checkAuthorized(allowedRoles, roles)
  ) {
    const isMember = roles.includes(ROLES_LIST.Mitglied);
    const fallbackPath = isMember ? "/dashboard/overview" : "/dashboard/app";
    return <Navigate to={fallbackPath} state={{ from: location }} replace />;
  }

  return <Outlet />;
};

RequireAuth.propTypes = {
  allowedRoles: PropTypes.arrayOf(PropTypes.number),
};

export default RequireAuth;
